<template>
  <div id="app">
    <app-header></app-header>
    <div id="header-separator" />
    <router-view></router-view>
  </div>
</template>

<script>
import AppHeader from './components/Header.vue'
import {loadFrontendFaces} from './util/faces'
import {mapGetters} from 'vuex';

export default {
  name: 'app',
  components: {
    AppHeader
  },
  computed: mapGetters(['isLoggedIn']),
  created () {
    if (this.isLoggedIn) {
      loadFrontendFaces()
    }
  }
}
</script>

<style>
/* app copied below */
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
} */

#header-separator {
  height: 20px;
}

/* Scrolling issue on pull to refresh on recent detections page. Remove bounce.*/
/* https://stackoverflow.com/questions/21209223/remove-bounce-on-scroll-in-browser-issue-with-positionfixed-div */

html, body {
    height: 100%;
    overflow: hidden;
}

#app {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: auto;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}

</style>



// WEBPACK FOOTER //
// App.vue?4c7e65fc